import { render, staticRenderFns } from "./WeChatService.vue?vue&type=template&id=2c5cb344&scoped=true"
import script from "./WeChatService.vue?vue&type=script&lang=js"
export * from "./WeChatService.vue?vue&type=script&lang=js"
import style0 from "./WeChatService.vue?vue&type=style&index=0&id=2c5cb344&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5cb344",
  null
  
)

export default component.exports